/** CoStar.Api.AnalyticReports.MarketReports.GeographyIdType */
export var GeographyIdType;
(function (GeographyIdType) {
    GeographyIdType[GeographyIdType["SubmarketId"] = 0] = "SubmarketId";
    GeographyIdType[GeographyIdType["ClusterId"] = 1] = "ClusterId";
    GeographyIdType[GeographyIdType["CoreBasedStatisticalAreaId"] = 2] = "CoreBasedStatisticalAreaId";
    GeographyIdType[GeographyIdType["ResearchMarketId"] = 3] = "ResearchMarketId";
    GeographyIdType[GeographyIdType["NationalId"] = 4] = "NationalId";
    GeographyIdType[GeographyIdType["CountyId"] = 5] = "CountyId";
    GeographyIdType[GeographyIdType["CityId"] = 6] = "CityId";
    GeographyIdType[GeographyIdType["NationalMajorId"] = 7] = "NationalMajorId";
    GeographyIdType[GeographyIdType["CollegeId"] = 20] = "CollegeId";
    GeographyIdType[GeographyIdType["CollegeNationalId"] = 27] = "CollegeNationalId";
    GeographyIdType[GeographyIdType["CoStarProductMarketId"] = 31] = "CoStarProductMarketId";
    GeographyIdType[GeographyIdType["CoStarProductCountryMajorMarketsId"] = 37] = "CoStarProductCountryMajorMarketsId";
    GeographyIdType[GeographyIdType["CoStarProductCountryId"] = 44] = "CoStarProductCountryId";
    GeographyIdType[GeographyIdType["CoStarCollegeCountryId"] = 47] = "CoStarCollegeCountryId";
})(GeographyIdType || (GeographyIdType = {}));
